<template>
  <div class="sign-info-detail">
    <span class="total">若信息有误或修改信息，请前往【首页】NOC官网进行咨询</span>
    <div class="sign-info-detail-content" style="margin-top: 40px">
      <h2>赛项信息</h2>
      <p><span>组别</span>{{ user.group }}</p>
      <p><span>编程语言</span>{{ user.language }}</p>
      <p><span>赛段</span>{{ currentStage }}</p>
      <p><span>比赛时间</span>{{ currentCompTime }}</p>
      <p><span>竞赛编号</span>{{ user.compCode }}</p>
    </div>
    <div class="sign-info-detail-content">
      <h2>选手基本信息</h2>
      <p><span>姓名</span>{{user.competitorOne}}</p>
      <p><span>手机号</span>{{user.mobileOne}}</p>
      <p v-if="user.city"><span>省市</span>{{user.province}} {{user.city}}</p>
      <p v-if="user.schoolOne"><span>学籍学校全称</span>{{user.schoolOne}}</p>
    </div>
    <div v-if="user.tetherName || user.tetherMobile || user.tetherCompany" class="sign-info-detail-content">
      <h2>指导老师信息</h2>
      <p><span>姓名</span>{{ user.tetherName }}</p>
      <p><span>电话</span>{{ user.tetherMobile }}</p>
      <p><span>单位</span>{{ user.tetherCompany }}</p>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { handelMobile } from '@/utils/utils';
import cardIdOptions from "./options/cardId-options";
import dayjs from 'dayjs';
export default {
  data() {
    return {};
  },
  mounted() {
    this.getRegInfo()
  },
  computed:{
    ...mapState({
      user: state => state.user.userInfo,
    }),
    ...mapGetters(['currentStage', 'currentCompTime'])
  },
  methods: {
    ...mapActions(['getStudentNocInfo','setActiveIndex','setModifyStatus']),
    goBack(){
      this.$emit('goBack')
    },
    async getRegInfo(){
      this.getStudentNocInfo()
    },
    edit(){
      this.setActiveIndex(1)
      this.setModifyStatus(true)
    }
  },
  watch: {
    userEntry(){
      const { mobile, teacherPhone, birthday, identityType, teacherIdentityType } = this.userEntry
      this.userEntry.mobileStr = handelMobile(mobile)
      this.userEntry.teacherPhoneStr = handelMobile(teacherPhone)
      birthday && (this.userEntry.birthdayStr = dayjs(birthday).format('YYYY/MM/DD'))
      if(identityType) {
        const identityTypeObj = cardIdOptions.find(item=>item.id == identityType)
        identityTypeObj && (this.userEntry.identityTypeStr = identityTypeObj.name)
      }
      if(teacherIdentityType) {
        const teacherIdentityTypeObj = cardIdOptions.find(item=>item.id == teacherIdentityType)
        teacherIdentityTypeObj && (this.userEntry.teacherIdentityTypeStr = teacherIdentityTypeObj.name)
      } 
    },
  }
}
</script>

<style lang="less" scoped>

.sign-info-detail {
  padding-top: 8px;
  position: relative;
  .back {
    cursor: pointer;
    font-size: 16px;
    position: absolute;
    left: 35px;
    top: 24px;
  }
  .total{
    color:#0A83DB;
    position: absolute;
    font-size: 16px;
    right: 35px;
  }
  .sign-info-detail-content {
    width: 646px;
    background: #FFFFFF;
    border: 1px solid #DFDFDF;
    border-radius: 4px;
    margin: 16px auto 0;
    padding-bottom: 8px;
    h2 {
      height: 40px;
      background-color: #f7f7f7;
      margin: 0;
      border-bottom: 1px solid #DFDFDF;
      color: #333;
      font-size: 16px;
      font-weight: 500;
      line-height: 40px;
      position: relative;
      padding-left: 23px;
      border-radius: 4px 4px 0 0;
      margin-bottom: 16px;
      &::before {
        content: ' ';
        position: absolute;
        left: 16px;
        top: 12.5px;
        width: 3px;
        height: 15px;
        background-color: #0A83DB;
        border-radius: 4px;
      }
    }
    p {
      position: relative;
      padding-left: 155px;
      color: #333;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      min-height: 22px;
      margin: 0 0 8px 0;
      word-break: break-all;
      span {
        display: inline-block;
        padding-left: 20px;
        position: absolute;
        left: 16px;
        top: 0;
        color: #999;
        min-width: 85px;
        text-align: justify;
        text-align-last: justify;
        &::after {
          content: "：";
          position: absolute;
          right: -17px;
          top: 0;
        }
      }
    }
  }
  .edit-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 55px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    text-align: center;
    /deep/ .el-button{
      margin-top: 8px;
    }
  }
}

</style>